import { getPreferencesAccess } from "../../preferences-access";

interface PushDashboardAccessLocals {
  activeUser: {
    organizationId?: string;
    organizationRoleId?: string;
    pushAccountInfo?: unknown;
  };
  organizationOwner?: { pushAccountInfo?: unknown } | null;
  organizationRoles?: unknown;
}

/**
 * Whether the signed-in user can see and edit the PUSH Daily Dashboard defaults: the account the
 * PUSH tab belongs to must be a PUSH coach, and an organization member that is not Owner or Admin
 * cannot edit. Same rules the Preferences page uses to show the PUSH tab, so nothing is requested
 * for anyone who cannot use the section.
 */
export const canManagePushDashboardDefaults = (
  locals: PushDashboardAccessLocals
): boolean => {
  const { notAbleToEdit, accountOfTheTab } = getPreferencesAccess(locals);

  return (
    Boolean(
      (
        accountOfTheTab as
          | PushDashboardAccessLocals["activeUser"]
          | null
          | undefined
      )?.pushAccountInfo
    ) && !notAbleToEdit
  );
};
